import { Space, Typography } from "antd";
import { QuestionsMark } from "../../../../Intervistat/Kandidatet/ShtoKandidat/Image";

const { Text } = Typography;

export const getWarningObj = ({
  icon,
  title,
  okText,
  content,
  cancelText,
  isDarkMode,
  subContent = true,
  onConfirm = () => {},
}) => {
  return {
    title,
    icon: icon || <QuestionsMark />,
    content: (
      <Space direction="vertical">
        <Text>{content}</Text>
        {!!subContent ? (
          <Text>
            Nëse jeni të sigurt për këtë veprim, klikoni
            <span className="text-bold">"{okText || "Po, anulloje"}"</span>
          </Text>
        ) : null}
      </Space>
    ),
    okText: okText || "Po, anulloje",
    cancelText: cancelText || "Jo, mos e anullo",
    width: "660px",
    className: `cancelModal ${isDarkMode ? "dark" : ""}`,
    centered: true,
    cancelButtonProps: {
      type: "primary",
      style: {
        background: "#ea3943",
        borderColor: "#ea3943",
        borderRadius: "5px",
      },
    },
    okButtonProps: {
      className: "ant-btn-confirm",
    },
    onOk() {
      onConfirm();
    },
    onCancel() {},
  };
};
